import { Component, HostListener, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-old-footer',
  styleUrls: ['./old-footer.component.scss'],
  templateUrl: './old-footer.component.html'
})
export class OldFooterComponent implements OnInit {
  assetsUrl = environment.assetsUrl;
  @Input() footerLite: any;
  @Input() footerError: any;
  @Input() isCDTConfig: any;
  @Input() isBiometrics: any;
  @Input() whiteHeader: any;
  isDesktopDevice!: boolean;

  ngOnInit(): void {
    this.isDesktopDevice = window.matchMedia('(min-width: 599px)').matches;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isDesktopDevice = window.innerWidth >= 599;
  }
}
